import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { normalizeRoleList } from '@/utils/privilegedRoleAccess'
import {
  setStoredCompanyFulfillmentSites,
  removeStoredCompanyFulfillmentSites
} from '@/utils/companyFulfillmentSitesStorage'

const user = {
  state: {
    token: getToken(),
    name: '',
    /** 管理员姓名（/admin/info 的 nickName），与登录帐号 username 区分 */
    nickName: '',
    avatar: '',
    /** GET /admin/info 的 companyIds，无配置为 [] */
    companyIds: [],
    roles: [],
    /**
     * GET /admin/info 的 data.integrationModuleScope（IntegrationModuleScopeVO）。
     * 五项布尔 flag 与《管理后台-兑换积分相关角色与权限说明》一致：
     * memberRegisterAllowed / giftIntegrationAllowed / giftVerifyCardAllowed /
     * giftReasonCategoriesAllowed / verifyCardAllowed / integrationActivationAllowed
     */
    integrationModuleScope: null,
    /**
     * GET /admin/info 的 companyFulfillmentSites（与 localStorage 同步，见 companyFulfillmentSitesStorage）
     * 每项：{ companyId, siteIds }
     */
    companyFulfillmentSites: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_NICK_NAME: (state, nickName) => {
      state.nickName = nickName || ''
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_COMPANY_IDS: (state, ids) => {
      state.companyIds = Array.isArray(ids) ? ids : []
    },
    SET_INTEGRATION_MODULE_SCOPE: (state, scope) => {
      state.integrationModuleScope = (scope && typeof scope === 'object') ? scope : null
    },
    SET_COMPANY_FULFILLMENT_SITES: (state, list) => {
      state.companyFulfillmentSites = Array.isArray(list) ? list : []
    }
  },

  actions: {
    // 登录
    Login({ commit, dispatch }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          const data = response.data
          const tokenStr = data.tokenHead+data.token
          dispatch('DisableOpenEmbedMode', null, { root: true })
          setToken(tokenStr)
          commit('SET_TOKEN', tokenStr)
          removeStoredCompanyFulfillmentSites()
          commit('SET_COMPANY_FULFILLMENT_SITES', [])
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const data = response.data
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', normalizeRoleList(data.roles))
          } else {
            reject('getInfo: roles must be a non-null array !')
          }
          commit('SET_NAME', data.username)
          commit('SET_NICK_NAME', data.nickName != null ? data.nickName : data.nickname)
          commit('SET_AVATAR', data.icon)
          commit('SET_COMPANY_IDS', data.companyIds)
          commit('SET_INTEGRATION_MODULE_SCOPE', data.integrationModuleScope || null)
          const sites = setStoredCompanyFulfillmentSites(data.companyFulfillmentSites)
          commit('SET_COMPANY_FULFILLMENT_SITES', sites)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          dispatch('DisableOpenEmbedMode', null, { root: true })
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_COMPANY_IDS', [])
          commit('SET_INTEGRATION_MODULE_SCOPE', null)
          commit('SET_COMPANY_FULFILLMENT_SITES', [])
          removeStoredCompanyFulfillmentSites()
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit, dispatch }) {
      return new Promise(resolve => {
        dispatch('DisableOpenEmbedMode', null, { root: true })
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        commit('SET_NICK_NAME', '')
        commit('SET_COMPANY_IDS', [])
        commit('SET_INTEGRATION_MODULE_SCOPE', null)
        commit('SET_COMPANY_FULFILLMENT_SITES', [])
        removeStoredCompanyFulfillmentSites()
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js